import { useCallback, useRef } from 'react';

export const useRequestPoolController = () => {
    const dependenciesRef = useRef();
    const setDependencies = useCallback((...dependencies) => {
        const newHash = dependencies.join('-');
        const changed = dependenciesRef.current !== newHash;
        dependenciesRef.current = newHash;

        return changed;
    }, []);

    return setDependencies;
};
